import React from "react";
import ModuleNavigation from "../ModuleNavigation";

export default function WebstoreModule() {
  return <ModuleNavigation moduleId="WebstoreModule" />;
}
